<template>
  <div class="agent-withdraw">
    <div class="withdraw-box">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span class="card-title">{{ $t('RewardCenter.AgentWithdraw.Title') }}</span>
        </div>
        <!-- <div>
          <el-alert
            center
            type="warning"
            :title="$t('RewardCenter.AgentWithdraw.Tip')"
          ></el-alert>
        </div> -->
        <el-row :gutter="20" style="display:flex;justify-content:space-between">
          <el-col :span="12">
        <div class="content-box ct-margin-top">
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.WithdrawAccount') }}</div>
            <!-- <div class="ct-ts" style="width: 50%">
              <img src="../../assets/alipay.png" alt="" />
              <div class="item-v">{{ agentAccData.withdraw_account.Alipay.AccountNumber }}</div>
            </div> -->
            <!-- <el-select v-model="selectChenle">
                <el-option :label="$t('RewardCenter.BindAccPage.AliPay')" value="AliPay">{{ agentAccData.withdraw_account.Alipay.AccountNumber }}</el-option>
              </el-select> -->
              <el-select v-model="selectChenle" @change="handerChennle" slot="reference">
                <!-- <el-option :label="agentAccData.withdraw_account.Alipay.AccountNumber" value="Alipay">{{agentAccData.withdraw_account.Alipay.AccountNumber}}</el-option> -->
                <!-- <el-option :label="agentAccData.withdraw_account.Bank.AccountNumber" value="Bank">{{agentAccData.withdraw_account.Bank.AccountNumber}}</el-option> -->
                <!-- <el-option :label="agentAccData.withdraw_account.USDT.Address" value="USDT">{{ agentAccData.withdraw_account.USDT.Address }}</el-option> -->
                <el-option v-if="alipayObj" :label="alipayObj.AccountNumber" value="Alipay">{{alipayObj.AccountNumber}}</el-option>
                <el-option v-if="bankObj" :label="bankObj.AccountNumber" value="Bank">{{bankObj.AccountNumber}}</el-option>
                <el-option v-if="USDTObj" :label="USDTObj.Address" value="USDT">{{USDTObj.Address}}</el-option>
              </el-select>
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.Currency') }}</div>
            <!-- <div class="acc" style="width: 50%">$ {{ formatNum(agentAccData.balance) }}</div> -->
            <div class="acc" style="width: 50%">{{ tCurrency }}</div>
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.Balance') }}</div>
            <!-- <div class="acc" style="width: 50%">$ {{ formatNum(agentAccData.balance) }}</div> -->
            <div class="acc" style="width: 50%">$ {{agentAccData.balance}}</div>
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.Rate') }}</div>
            <!-- <div class="acc" style="width: 50%">$ {{ formatNum(agentAccData.balance) }}</div> -->
            <div class="acc" style="width: 50%">{{ tRate }}</div>
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.WithdrawAmount') }}</div>
            <CInput
              type="text"
              style="margin-bottom: 0; width: 50%"
              v-model="amount"
              :invalid-feedback="errorBackAmount"
              :is-valid="validatorAmount"
              valid-feedback=""
            />
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.TransferAcc') }}</div>
            <!-- <div class="acc" style="width: 50%">$ {{ formatNum(agentAccData.balance) }}</div> -->
            <div class="acc" style="width: 50%">{{ tAmount }}</div>
          </div>
          <div class="ct-box ct-margin-top" style="padding-left:56px">
            <button @click="submitWithdraw" class="btn custer sbtn" type="button">
              {{ $t("RewardCenter.TransferToAcc.TransferConfirm") }}
            </button>
          </div>
        </div>
        </el-col>
        <el-col :span="8" style="margin-top:75px" v-if="visipopver">
        <el-popover
          placement="right"
          width="400"
          v-model="visipopver"
          trigger="click">
          <div>
            <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.AccountName') }}</div>
              <div class="acc" style="width: 50%">{{bankObj.AccountName}}</div>
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.AccountNumber') }}</div>
            <!-- <div class="acc" style="width: 50%">$ {{ formatNum(agentAccData.balance) }}</div> -->
            <div class="acc" style="width: 50%">{{bankObj.AccountNumber}}</div>
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.BankName') }}</div>
            <div class="acc" style="width: 50%">{{bankObj.BankName}}</div>
          </div>
          <div class="ct-box">
            <div class="ct-lable">{{ $t('RewardCenter.AgentWithdraw.BankCode') }}</div>
            <div class="acc" style="width: 50%">{{bankObj.BankCode}}</div>
          </div>
          <div class="ct-box">
            <div class="ct-lable">Swift Code</div>
            <div class="acc" style="width: 50%">{{bankObj.SwiftCode}}</div>
          </div>
          </div>
        </el-popover>
        </el-col>
        </el-row>
      </el-card>
    </div>
    <AliyunCaptchaGuard
      ref="agentWithdrawCaptchaGuard"
      cache-key="agent-withdraw-captcha"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { agentWithdraw } from "../../api/http"
import AliyunCaptchaGuard from '@/components/AliyunCaptchaGuard.vue'
export default {
  components: {
    AliyunCaptchaGuard
  },
  data() {
    return {
      amount: null,
      errorBackAmount: "",
      flags: false,
      selectChenle: "",
      visipopver: false,
      tCurrency: "USDT",
      tRate: 1,
      ipUrl: "",
      ty: "",
      alipayObj: "",
      bankObj: "",
      USDTObj: ""
    };
  },
  computed: {
    ...mapState(["agentAccData"]),
    // 轉賬金額  提現金額 * 匯率 
    tAmount() {
      return (Number(this.amount) * Number(this.tRate)).toFixed(2)
    }
  },
  watch: {
    selectChenle(val) {
      if(val == "Alipay") {
        this.tCurrency = "CNY"
        this.getCnyRate()
        this.ty = this.$store.state.agentAccData.withdraw_account.Alipay.AccountNumber
      }else if(val == "Bank") {
        this.tCurrency = "USD"
        this.tRate = 1
        this.ty = this.$store.state.agentAccData.withdraw_account.Bank.AccountNumber
      }else {
        this.tCurrency = "USDT"
        this.tRate = 1
        this.ty = this.$store.state.agentAccData.withdraw_account.USDT.Address
      }
    },
    // 監聽賬戶
    "agentAccData.withdraw_account": {
      handler(val) {
        console.log("val==>", val)
        this.alipayObj = val.Alipay == undefined ? "" : val.Alipay
        this.bankObj = val.Bank == undefined ? "" : val.Bank
        this.USDTObj = val.USDT == undefined ? "" : val.USDT
         if (val == null || val.length == 0) {
          this.$confirm(
            this.$t('RewardCenter.AgentWithdraw.Diglog'),
            "",
            {
              confirmButtonText: this.$t("Funds.Inwardrem.TipsButton2"),
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false,
              type: "warning",
            }
          ).then(() => {
              this.$router.push("/reward-center/bind-usdt-acc");
            })
            .catch(() => {
              // this.$message.error(e)
            });;
        }
      },
    },

    "agentAccData.withdraw_account": {
      handler(val) {
        if (!val) return;

        this.alipayObj = val.Alipay || "";
        this.bankObj = val.Bank || "";
        this.USDTObj = val.USDT || "";

        // ✅ 初始化 selectChenle（只初始化一次）
        if (!this.selectChenle) {
          if (val.Alipay) {
            this.selectChenle = "Alipay";
          } else if (val.Bank) {
            this.selectChenle = "Bank";
          } else if (val.USDT) {
            this.selectChenle = "USDT";
          }
        }
      },
      immediate: true
    }
  },
  created() {
      this.$store.dispatch("getAgentAcc")
      // this.getCnyRate()
      // this.ty = this.$store.state.agentAccData.withdraw_account.Alipay.AccountNumber
  },
  methods: {
    clickTest() {
      this.$axios.post("/apil/cityjson?ie=utf-8", {}).then(res => {
        console.log("res==>", res)
      })
    },
    formatNum(value) {
      if (!value && value !== 0) return 0;

      let str = value.toString();
      let reg =
        str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, "$1,");
    },
    // 显示隐藏银行账户详细信息
    handerChennle(e) {
      console.log('eee==>', e) 
      if(e == "Bank") {
        this.visipopver = true
      }else {
        this.visipopver = false
      }
    },
    // 獲取代理提現人民幣費率
    getCnyRate() {
      let data = {
        type: "get_cny_withdraw_rate",
        uid: window.localStorage.getItem("uid")
      };
      let formData = new URLSearchParams()
      for (let k in data) {
        formData.append(k, data[k]);
      }
      this.$axios({
        method: "POST",
        url: "/request/user.php",
        // url: process.env.VUE_APP_BASE_URL+"/request/user.php",
        data: formData,
      }).then((res) => {
        console.log("res", res)
        if (res.data.code == 200) {
          this.tRate = res.data.data.rate
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 提交提現
    submitWithdraw() {
        if(this.flags == true || this.amount == null) {
            return
        }
        let data = {
            type: "agent_withdraw",
            uid: localStorage.getItem('uid'),
            amount: this.amount,
            // account: this.ty || this.$store.state.agentAccData.withdraw_account.Alipay.AccountNumber
            account: this.selectChenle == "Alipay" ? this.$store.state.agentAccData.withdraw_account.Alipay.AccountNumber : this.selectChenle == "Bank" ? this.$store.state.agentAccData.withdraw_account.Bank.AccountNumber : this.$store.state.agentAccData.withdraw_account.USDT.Address
        }
        this.$refs.agentWithdrawCaptchaGuard.execute((captchaVerifyParam) => {
            return agentWithdraw({
                ...data,
                captcha_verify_param: captchaVerifyParam
            })
        }, {
            isSuccess: (res) => Number(res.code) === 200
        }).then((res) => {
            if(res.code == 200) {
                this.$message.success(res.message)
                this.amount = null
                this.$router.push("/reward-center/account")
            }else {
                this.$message.error(res.message)
            }
        }).catch((error) => {
            if (error && error.code !== 'CAPTCHA_DESTROYED') {
                this.$message.error(error.message || 'Error')
            }
        })
    },
    // 驗證最低金額
    validatorAmount(val) {
      let reg = /^(\+)?\d+(\.\d+)?$/;
      if (val === null) {
        this.errorBackAmount = "";
        this.flags = false;
        return;
      }
      if (val < 50) {
        this.errorBackAmount = this.$t('RewardCenter.AgentWithdraw.WithdrawAmountTip');
        this.flags = true;
        return false;
      }
      if (reg.test(val)) {
        this.errorBackAmount = "";
        this.flags = false;
        return true;
      } else {
        this.errorBackAmount = this.$t("AliPay.InputTip");
        this.flags = true;
        return false;
      }
    },
  },
};
</script>

<style scoped>
.ct-ts {
  display: flex;
  align-items: center;
}
.item-v {
  margin-left: 0.1rem;
  color: #42474d;
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.agent-withdraw {
  padding-left: 2.6rem;
  height: 100%;
  background: #fff;
}
.sbtn:hover {
  background: rgba(0, 190, 164, 0.8) !important;
}
.sbtn:focus {
  border-color: #00bea4;
  box-shadow: 0 0 0 0.25rem rgba(0, 190, 164, 0.5) !important;
}
.custer {
  background: #00bea4;
  color: #fff;
  width: 100%;
  outline: 0;
}
.withdraw-box {
  width: 83%;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.card-title {
  font-weight: bold;
  font-size: 1.1rem;
}
.content-box {
  width: 360px;
  margin: 0 auto;
}
.ct-box {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  width: 100%;
}
.ct-lable {
  width: 73%;
  color: #42474d;
  font-size: 14px;
  text-align: right;
  padding-right: 7rem;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.acc {
  color: #42474d;
  font-size: 14px;
  font-family: AxLLCircular, Helvetica, Arialsans-serif;
}
.ct-margin-top {
  margin-top: 2rem;
}
</style>
